import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';

class BatchReceive extends Component {
    state = {
        columns: [
            {
                title: '序号',
                key: 'index',
                align: 'center',
                render: (text, record, index) => {
                    //生成序号
                    return (
                        <span>{index + 1}</span>
                    )
                },
            },
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
            },
        ],
        msgStatus: 0
    }

    handleOk = () => {
        this.props.onRef(false);    //关闭弹框
        this.props.refreshTable();  //刷新静息心电列表
    }

    render() {
        const { visible, sucBatchMsg, errBatchMsg, infoBatchMsg, getBatchNum, getbatchTableList } = this.props
        return (
            <Modal
                className="consulationH"
                width={520}
                title="数据接收"
                visible={visible}       // 对话框是否可见
                closable={false}        // 是否显示右上角的关闭按钮
                maskClosable={false}    // 点击蒙层不允许关闭
                footer={
                    sucBatchMsg || errBatchMsg ?
                        <Button key="back" type="primary" onClick={this.handleOk}>确定</Button> : null
                }
            >
                <div className="receiveTitle">"正在接收数据，请等待..."</div>

                <ul className="receiveMsg">
                    <li>接收数据成功：<span style={{ color: '#21B04B' }}>{getBatchNum.SucPatNum}</span> 例</li>
                    <li>接收数据失败：<span style={{ color: "#EC1A23" }}>{getBatchNum.ErrPatNum}</span> 例</li>
                    <li>匹配HIS信息失败：<span style={{ color: "#00A1E7" }}>{getBatchNum.ErrMatchNum}</span> 例</li>
                </ul>

                {
                    sucBatchMsg === 'RV_SUC_BATCH_FINISH' ?
                        <div className="receiveMsgStatus" style={{ color: '#21B04B' }} >接收完成！</div> : null
                }
                {
                    errBatchMsg === 'RV_ERR_BATCH' ?
                        <div className="receiveMsgStatus" style={{ color: '#EC1A23' }} >接收失败！</div> : null
                }
                {
                    infoBatchMsg === 'RV_ERR_BATCH_TRANS' ?
                        <div className="receiveMsgStatus" style={{ color: '#00A1E7' }} >存在转换失败的数据！</div> : null
                }

                {
                    getbatchTableList ?
                        <div className="batchReceiveWrap">
                            <Table
                                dataSource={getbatchTableList}
                                columns={this.state.columns}
                                pagination={false}
                                rowKey={(record) => record.key}
                            />
                        </div> : null
                }

            </Modal>
        )
    }
}

export default BatchReceive;